import { render } from "./Timecurrent.vue?vue&type=template&id=2ab2851d&scoped=true"
import script from "./Timecurrent.vue?vue&type=script&lang=js"
export * from "./Timecurrent.vue?vue&type=script&lang=js"

import "./Timecurrent.vue?vue&type=style&index=0&id=2ab2851d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kamon\\Documents\\Workspace\\ECOUPONS\\coupons-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab2851d"]])

export default __exports__